import { searchClient } from '@/globals/algolia.global';
import { IPlatform } from '@/types';
import Image from 'next/image';
import { Configure, InstantSearch } from 'react-instantsearch-dom';
import { LocalSearchBox } from '../searchBox/searchBox.comp';
import { StyledHero } from './discoverHero.styles';

import image3 from '../../../public/assets/developers-hero-left.svg';
import image1 from '../../../public/assets/developers-hero-middle.png';
import image2 from '../../../public/assets/developers-hero-right.svg';

export const DiscoverHero = ({
	platforms,
	totalApps,
}: {
	platforms: IPlatform[];
	totalApps: number;
}) => {
	return (
		<StyledHero>
			<div className="hero-content-container">
				<h1>Discover the best apps for your website</h1>
				<h2>
					<span>{totalApps.toLocaleString()}</span> third-party apps are waiting
					to be uncovered
				</h2>
				<InstantSearch
					indexName={process.env.NEXT_PUBLIC_ALGOLIA_APPS_INDEX as string}
					searchClient={searchClient}
				>
					<Configure
						hitsPerPage={10}
						analytics={false}
						enablePersonalization={false}
						distinct
					/>
					<LocalSearchBox
						searchAsYouType={true}
						enableAutoComplete={true}
						platforms={platforms as any}
					/>
				</InstantSearch>
				<Image
					className="icons-img middle"
					src={image1}
					alt="squares"
					width={1554}
					height={802}
				/>
				<Image
					className="icons-img right"
					src={image2}
					alt="e-commerce platforms"
					width={345}
					height={397}
				/>
				<Image
					className="icons-img left"
					src={image3}
					alt="e-commerce platforms"
					width={373}
					height={445}
				/>
			</div>
		</StyledHero>
	);
};
